module.exports = __webpack_public_path__ + "img/horizontal_7_4_pp2_8023.d18e347f.png";